import { InferenceClient } from "@huggingface/inference";

const getResponse = async (messages) => {
  console.log(messages);
  const client = new InferenceClient(
    import.meta.env.VITE_HUGGING_FACE_API_TOKEN,
  );

  const chatCompletion = await client.chatCompletion({
    provider: "featherless-ai",
    model: "mistralai/Magistral-Small-2506",
    messages,
  });

  console.log(chatCompletion.choices[0].message);

  return chatCompletion.choices[0].message;
};

export { getResponse };
